import { Injectable } from '@angular/core';
//import { SubsectorClass } from '../models/subsector.class';
import { Subsector } from '../interfaces/subsector.interface';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubsectorService {

    private subsectorUrl = environment.apiUrl + '/handlers/subsectorgetall.php';  // URL to web api
    subsector: Subsector[] = [];

    //private headers = new Headers({'Content-Type': 'application/json'});
    constructor(private http: HttpClient) { }
    
    async getSubsector(): Promise<Subsector[]> {
      let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
        const data$ = this.http.post<Subsector[]>(this.subsectorUrl,JSON.stringify({ distid: distid }))
        try {
          this.subsector = await firstValueFrom(data$);
          return this.subsector;
        }
        catch (error) {
          console.error(
            'There was an error!', error);
            throw error;
        };  
        
     }
}
